<template>
  <div style="display: contents">
    <bkf-action
      v-if="buttonStyle == 'icon'"
      :tooltip="$trans('v2.i2m_components.actions.add')"
      @click="open()"
    >
      <v-icon>
        add
      </v-icon>
    </bkf-action>
    <v-btn
      v-else-if="buttonStyle == 'text'"
      color="primary"
      tile
      @click="open()"
    >
      {{ title|trans }}
    </v-btn>
    <v-dialog
      v-model="show"
      :fullscreen="$vuetify.breakpoint.mobile"
      max-width="40%"
      eager
      transform-origin="bottom center"
    >
      <v-card class="d-flex flex-column">
        <v-toolbar
          dark
          color="primary"
          class="flex-grow-0"
        >
          <v-toolbar-title>{{ title|trans }}</v-toolbar-title>
          <v-spacer />
          <v-btn
            icon
            dark
            @click="showDialog = false"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text class="pt-4 flex-grow-1">
          <bkf-form-simple
            v-if="show"
            ref="formSimple"
            :form-url="`${actionUrl}/new`"
            :action-url="actionUrl"
            :context="context"
            :entry="entry"
            :options="options"
            submit-text="dialog.add"
            request-method="post"
            @fetching="onFetching"
            @fetched="onFetched"
            @fetchError="onFetchError"
            @submitting="onSubmitting"
            @submitted="onSubmitted"
            @submitError="onSubmitError"
            @validate-error="onValidateError"
          />
        </v-card-text>
        <v-spacer />
        <v-divider />
      </v-card>
    </v-dialog>
  </div>
</template>

<script lang="ts">
import BkfFormSimple from '../Form/Form.vue';

// States as events
const events = {
  fetching: 'fetching',
  fetched: 'fetched',
  fetchError: 'fetchError',
  submitting: 'updating',
  submitted: 'updated',
  submitError: 'updateError',
  validateError: 'validateError',
};

export default {
  components: {
    BkfFormSimple,
  },
  props: {
    requestMethod: {
      type: String,
      required: false,
      default: 'post',
    },
    title: {
      type: String,
      required: false,
      default: '',
    },
    actionUrl: {
      type: String,
      required: false,
      default: null,
    },
    context: {
      type: String,
      required: false,
      default: null,
    },
    buttonStyle: {
      type: String,
      required: false,
      default: 'icon',
    },
  },
  data: () => ({
    show: false,
    showDialog: false,
    fetching: false,
    submitting: false,
    entry: null,
    options: {},
  }),
  watch: {
    showDialog(newValue) {
      if (newValue === false) {
        this.onClose();
      }
    },
  },
  methods: {
    open(entry, options = {}) {
      this.fetching = false;
      this.submitting = false;
      this.show = true;
      this.entry = entry || null;
      this.options = options;
    },
    submit() {
      this.$refs.form.submit();
    },
    async onClose() {
      this.$emit('close');
      await this.$sleep(500);
      this.show = false;
    },
    onFetching() {
      this.fetching = true;
      this.$emit(events.fetching);
    },
    onFetched() {
      this.fetching = false;
      this.$emit(events.fetched);
      this.showDialog = true;
    },
    onFetchError(payload) {
      this.fetching = false;
      this.show = false;
      this.$emit(events.fetchError, payload);
    },
    onSubmitting() {
      this.submitting = true;
    },
    async onSubmitted(payload) {
      this.$emit(events.submitted, payload);
      this.showDialog = false;
    },
    async onSubmitError(payload) {
      this.$emit(events.submitError, payload);
      this.showDialog = false;
    },
    onValidateError() {
      this.submitting = false;
      this.$emit(events.validateError);
    },
  },
};
</script>
